export default __webpack_public_path__ + "static/media/fifa-qna.2208eaed.webp";